angular
    .module("skillBuilderSaaS")
    .filter("version", function () {
    return function (value) {
        return value; //? parseFloat(value).toFixed(1).toString().replace(",", ".") : null;
    };
});
